export default __webpack_public_path__ + "static/media/(13).2d55da1a.jpg";